<template>
  <div class="extend_time__form">
    <v-form ref="form" v-model="valid" lazy-validation class="mt-6">
      <!-- สำนักงานปลัดกระทรวงอุดมศึกษาฯ (สป.อว.) -->
      <div class="custom_card mt-4">
        <v-layout justify-space-between pa-3>
          <v-flex shrink class="pr-4">
            <v-img
              :src="
                require('../../../../assets/images/extension-time/logo-rsp.png')
              "
              width="100"
              height="100"
            ></v-img>
          </v-flex>
          <v-flex xs8>
            <h1>
              สำนักงานปลัดกระทรวงการอุดมศึกษา วิทยาศาสตร์ วิจัยและนวัตกรรม
              (สป.อว.)
            </h1>
            <div class="font-12 font-w-400 mt-2">
              <Iconify
                class="mr-3"
                icon="ic:round-access-time"
                size="15px"
              ></Iconify>
              <span>
                วันที่เปิดรับโครงการ 31 พฤศจิกายน 2565 เวลา 00:00 น. - 30
                ธันวาคม 2565 เวลา 12:00 น.
              </span>
            </div>
            <div class="font-12 font-w-400 mt-2">
              <Iconify
                class="mr-3"
                icon="ic:round-access-time"
                size="15px"
              ></Iconify>
              <span>
                วันที่พิจารณาโครงการ 3 มกราคม 2566 เวลา 08:00 น. - 5 มกราคม 2566
                เวลา 12:00 น.
              </span>
            </div>
            <div class="font-12 font-w-400 pl-6 mt-2">
              โครงการส่งเสริมกิจการอุทยานวิทยาศาสตร์
              (นิคมธุรกิจวิทยาศาสตร์ภูมิภาค)
            </div>
          </v-flex>
          <v-spacer />
          <v-flex shrink>
            <div
              class="custom_card d-flex flex-column align-center justify-center"
              style="
                background-color: #f15a29;
                color: #fff;
                width: 100px;
                height: 100px;
                padding: 5px;
              "
            >
              <div class="font-20 font-w-600">ปี งปม.</div>
              <div class="font-32 font-w-600">2566</div>
              <div></div>
            </div>
          </v-flex>
        </v-layout>
      </div>

      <div class="font-20 font-w-600 mb-2 mt-5">แผนงาน</div>
      <div class="font-16 font-w-500 mb-6 custom_card">
        {{ plan_name }}
      </div>

      <div class="font-20 font-w-600 mb-4">รายการโครงการย่อยที่ขอขยายเวลา</div>

      <table class="custom_table mb-4">
        <thead>
          <tr>
            <th width="5%">ลำดับ</th>
            <th width="35%">ชื่อโครงการ</th>
            <th width="10%">มหาวิทยาลัย</th>
            <th width="10%">ผู้นำเข้าข้อมูล</th>
            <th width="10%" class="text-center">ครั้งที่</th>
            <th width="10%" class="text-center">ระยะที่ขอขยาย</th>
            <th width="10%" class="text-center">ขยายถึง</th>
            <th width="10%"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in form.pending_form_list" :key="i">
            <td>{{ i + 1 }}</td>
            <td>
              <div class="one-line">
                <tooltip-text :text="item?.project_name" />
              </div>
            </td>
            <td>
              <div class="one-line">
                <tooltip-text :text="item?.user?.university?.name_th" />
              </div>
            </td>
            <td>
              <div class="one-line">
                <tooltip-text :text="item?.created_by" />
              </div>
            </td>
            <td class="text-center">{{ item.round }}</td>
            <td class="text-center">{{ item.duration }}</td>
            <td class="text-center">{{ item.end_date }}</td>
            <td class="text-center">
              <span
                :style="
                  item.status == 'Approved'
                    ? { color: '#5CB844' }
                    : { color: '#F15A29' }
                "
              >
                {{ item.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="font-20 font-w-600 mb-4">รายละเอียดการขอขยายเวลา</div>

      <div class="custom_card pa-6">
        <v-layout class="mb-3">
          <v-flex xs1>
            <div class="font-14 font-w-600">
              เหตุผล <span style="color: #f15a29">*</span>
            </div>
          </v-flex>
          <v-flex xs11>
            <div class="font-14">
              {{ form.reason_rsp ? form.reason_rsp : "- ไม่มีข้อมูล -" }}
            </div>
          </v-flex>
        </v-layout>

        <div class="font-14 font-w-700 mb-2 mt-3">เอกสารเเนบ</div>

        <v-layout
          align-center
          class="mt-3"
          v-for="(file, f) in form.files"
          :key="f"
        >
          <v-flex shrink>
            <v-btn
              depressed
              dark
              rounded
              width="125"
              color="#F15A29"
              @click="downloadFile(file)"
            >
              <Iconify
                style="color: #fff"
                icon="system-uicons:download"
              ></Iconify>
              <span class="font-12 font-w-700">ดาวน์โหลด</span>
            </v-btn>
          </v-flex>
          <v-flex shrink ml-3>
            {{ file.file_name }}
          </v-flex>
        </v-layout>
      </div>

      <div class="custom_card mt-4">
        <!-- เหตุผลจากทาง สป -->
        <v-layout class="mb-3">
          <v-flex xs1>
            <div class="font-14 font-w-600">
              เหตุผลจากทาง สป <span style="color: #f15a29">*</span>
            </div>
          </v-flex>
          <v-flex xs11>
            <div class="font-14">
              {{ form.reason_sp ? form.reason_sp : "- ไม่มีข้อมูล -" }}
            </div>
          </v-flex>
        </v-layout>

        <div class="font-14 font-w-700 mb-2 mt-3">เอกสารเเนบ</div>

        <v-layout
          align-center
          class="mt-3"
          v-for="(file, f) in form.files_sp"
          :key="f"
        >
          <v-flex shrink>
            <v-btn
              depressed
              dark
              rounded
              width="125"
              color="#F15A29"
              @click="downloadFile(file)"
            >
              <Iconify
                style="color: #fff"
                icon="system-uicons:download"
              ></Iconify>
              <span class="font-12 font-w-700">ดาวน์โหลด</span>
            </v-btn>
          </v-flex>
          <v-flex shrink ml-3>
            {{ file.file_name }}
          </v-flex>
        </v-layout>
      </div>

      <v-layout class="mt-5">
        <v-flex shrink>
          <v-btn
            depressed
            dark
            rounded
            width="100"
            color="#D9D9D9"
            @click="$router.push('/sp/extend-time')"
          >
            <span class="font-14 font-w-700" style="color: #464647">
              ย้อนกลับ
            </span>
          </v-btn>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
import { apiDomain } from "../../../../store/constants";
import axios from "axios";
export default {
  data() {
    return {
      plan_name: "",
      form: {
        pending_group_id: null,
        plan_id: null,
        plan_master_id: null,
        fiscal_year: null,
        region: null,
        reason_sp: null,
        reason_rsp: null,
        pending_form_list: [],
        files: [],
        files_sp: [],
      },
    };
  },
  created() {
    console.log(this.$route.params.id);
    if (this.$route.params.id) {
      this.onView();
    }
  },
  methods: {
    async onView() {
      let res = await this.$apiFire("SPExtend/show", this.$route.params.id);
      if (res) {
        // set master data
        this.plan_name = res.plan.plan_master.plan_name_th;
        this.form.pending_form_list = res.pending_form_list;
        // set form data
        this.form.pending_group_id = res.data.pending_group_id;
        this.form.plan_id = res.data.plan_id;
        this.form.plan_master_id = res.data.plan_master_id;
        this.form.fiscal_year = res.data.fiscal_year;
        this.form.region = res.data.region;
        this.form.reason_rsp = res.data.reason_rsp;
        this.form.reason_sp = res.data.reason_ops;

        // set files rsp data
        res.data.pending_sub_group_rsp_attachments.forEach((file) => {
          this.form.files.push({
            id: file.attachment.id,
            parent_table: file.attachment.parent_table,
            parent_id: file.attachment.parent_id,
            file_name: file.attachment.file_name,
            file_path: file.attachment.file_path,
            file_extension: file.attachment.file_extension,
            full_path: file.attachment.full_path,
          });
        });

        // set files sp data
        res.data.pending_sub_group_sp_attachments.forEach((file) => {
          this.form.files_sp.push({
            id: file.attachment.id,
            parent_table: file.attachment.parent_table,
            parent_id: file.attachment.parent_id,
            file_name: file.attachment.file_name,
            file_path: file.attachment.file_path,
            file_extension: file.attachment.file_extension,
            full_path: file.attachment.full_path,
          });
        });
      }
    },
    downloadFile(file) {
      axios({
        url: `/api/download/${file.id}`,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.file_name);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.$store.commit("General/setModal", {
            title: "ระบบไม่พบไฟล์ที่ร้องขอ",
            theme: "warning",
            text: "กรุณาติดต่อเจ้าหน้าที่",
            showCancel: false,
            buttonText: "ตกลง",
          });
        });
    },
  },
};
</script>

<style lang="scss">
.extend_time__form {
  .custom_card {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding: 15px 25px;
  }

  .custom_table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin-bottom: 20px;
    thead {
      // background-color: #f2f2f2;
      color: #b1b1b1;
      th {
        padding: 12px;
        border-bottom: 1px solid #ddd;
        text-align: left;
      }
    }
    tbody {
      tr {
        &:nth-child(even) {
          // background-color: #f2f2f2;
        }
        td {
          padding: 12px;
        }
      }
    }
  }

  .custom_file_input {
    .v-text-field--full-width .v-input__prepend-outer,
    .v-text-field--full-width .v-input__prepend-inner,
    .v-text-field--full-width .v-input__append-inner,
    .v-text-field--full-width .v-input__append-outer,
    .v-text-field--enclosed .v-input__prepend-outer,
    .v-text-field--enclosed .v-input__prepend-inner,
    .v-text-field--enclosed .v-input__append-inner,
    .v-text-field--enclosed .v-input__append-outer {
      margin-top: 4px !important;
    }
  }

  .v-input__slot,
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: inherit !important;
  }
  .v-input--is-readonly:not(.picker-field) .v-input__slot {
    background-color: #ffffff !important;
  }

  .v-input__icon--clear {
    background: #d9d9d9;
    color: #fff !important;
  }

  .btn-save {
    background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
    padding: 0px 10px;
  }
  input {
    font-size: 16px !important;
  }
}
</style>
